import { Outlet, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ClipboardCheck, LogOut, GraduationCap } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import EvaluatorConsent from "@/pages/EvaluatorConsent";
import MainSiteLink from "@/components/MainSiteLink";

export default function EvaluatorLayout() {
  const { t } = useTranslation();
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const handleLogout = () => { logout(); navigate("/admin/login"); };

  if (user && user.role === "evaluator" && !user.consent_accepted_at) {
    return <EvaluatorConsent />;
  }

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border bg-card sticky top-0 z-10">
        <div className="max-w-5xl mx-auto flex items-center justify-between px-6 py-4">
          <div className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-lg bg-primary flex items-center justify-center">
              <GraduationCap className="w-5 h-5 text-primary-foreground" strokeWidth={1.5} />
            </div>
            <div>
              <p className="font-heading text-base font-semibold tracking-tight leading-none">{t("evaluator.brand")}</p>
              <p className="text-xs text-muted-foreground mt-0.5 flex items-center gap-1">
                <ClipboardCheck className="w-3 h-3" /> {t("evaluator.panel")}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-4">
            <MainSiteLink />
            <div className="text-right hidden md:block">
              <p className="text-sm font-medium leading-none">{user?.name}</p>
              <p className="text-xs text-muted-foreground mt-0.5">{user?.email}</p>
            </div>
            <Button variant="ghost" size="sm" className="text-muted-foreground" onClick={handleLogout} data-testid="evaluator-logout">
              <LogOut className="w-4 h-4 mr-2" strokeWidth={1.5} /> {t("common.sign_out")}
            </Button>
          </div>
        </div>
      </header>
      <main className="max-w-5xl mx-auto px-6 py-10">
        <Outlet />
      </main>
    </div>
  );
}
